import DeliveryCardContainer from './DeliveryCardContainer';

export default DeliveryCardContainer;
